import { useEffect } from "react";

/**
 * Custom hook for annotation keyboard shortcuts
 * Handles undo and delete operations
 */
export const useAnnotationKeyboard = (
  isAnnotating: boolean,
  canUndo: boolean,
  undo: () => void,
  selectedId: string | null,
  deleteAnnotation?: (id: string) => void,
  isDialogOpen: boolean = false,
) => {
  // Keyboard event handler for undo and delete (only in annotation mode)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Only handle keyboard shortcuts in annotation mode
      if (!isAnnotating) return;

      // Check for Ctrl+Z (Windows/Linux) or Cmd+Z (Mac)
      if ((e.ctrlKey || e.metaKey) && e.key === "z" && !e.shiftKey) {
        e.preventDefault();
        if (canUndo) {
          undo();
        }
      }

      // Check for Delete or Backspace key (skip if dialog is open)
      if (!isDialogOpen && (e.key === "Delete" || e.key === "Backspace") && selectedId && deleteAnnotation) {
        e.preventDefault();
        deleteAnnotation(selectedId);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isAnnotating, canUndo, undo, selectedId, deleteAnnotation, isDialogOpen]);
};
